import { createContext, FC, useCallback, useState } from "react";
import useCallToService from "../../../hooks/useCallToService";
import { setQueryFunction } from "../../StandardContextUtils";

type TransactionListQuery = {
  user: string;
  username: string;
  betId: string;
  betType: string;
  betTypeFromGame: string;
  gameBrand: string;
  gameCode: string;
  startDate: string;
  endDate: string;
  page: number;
  limit: number;
};

type TransactionListServiceContextProps = {
  id: string;
  query: TransactionListQuery;
  collection: any[];
  setQuery: (field: string, value: any) => void;
  onFetch: (token?: string) => void;
  setId: (param: any) => void;
};

const defaultContext: TransactionListServiceContextProps = {
  id: "",
  query: {
    user: "",
    username: "",
    betId: "",
    betType: "",
    betTypeFromGame: "",
    gameBrand: "",
    gameCode: "",
    startDate: "",
    endDate: "",
    page: 1,
    limit: 50,
  },
  collection: [],
  setId: (param: any) => { },
  setQuery: (field: string, value: any) => { },
  onFetch: (token?: string) => { },
};
const getServiceEndpoint = (id: string, manualId?: string) =>
  `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/v1/transaction/${manualId || id}/list`;
export const TransactionListServiceContext = createContext(defaultContext);
export const TransactionListServiceContextProvider: FC<any> = ({ children }) => {
  const [collection, setCollection] = useState([]);
  const [id, setId] = useState(defaultContext.id);
  const [query, setLocalQuery] = useState(defaultContext.query);
  const [callToService] = useCallToService();

  const onFetch = useCallback(async (manualId?: string) => {
    try {
      const response = await callToService(getServiceEndpoint(id, manualId), "POST", query);
      if (response.data) setCollection(response.data);
    } catch (error) {
    }
  }, [callToService, query, id]);
  const setQuery = setQueryFunction(query, setLocalQuery);

  return (
    <TransactionListServiceContext.Provider
      value={{
        id,
        query,
        collection,
        setQuery,
        onFetch,
        setId,
      }}>
      {children}
    </TransactionListServiceContext.Provider>
  );
};
